import React, { Component } from 'react'

import classes from './SetupPerspective.scss'
import {
  checkValidity,
  updateFormOptions,
  updateFilterOptions,
  updateObject,
  extractFilterOptions,
  validateForm
} from '../../../../helpers/utils'
import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
// import Button from '../../../../components/UI/Button/Button'
import Alert from '../../../../components/Alert/Alert'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import DataTable from '../../../../components/DataTable/DataTable'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import Form from '../../../../components/PageContent/SetupData/SetupPerspective/Form/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import Footer from '../../../../components/UI/Modal/Footer/Footer'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import { Checkbox } from '@material-ui/core'
import { Edit, Delete, Add } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'

class SetupPerspective extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    action: 'add',
    addAno: false,
    actionRecordId: null,
    assignmentTabs: {
      data_access: {
        label: this.props.translate('dataAccess'),
        data: {
          corporate: {
            label: this.props.translate('corporate'),
            value: '',
            code: '',
            companies: {
              label: this.props.translate('company'),
              value: [],
              elementConfig: {
                options: ['Test1', 'Test2'],
                placeholder: this.props.translate('selecct') + this.props.translate('corporate')
              },
              validation: {
                required: true
              },
              touched: false,
              valid: false,
              inputType: 'newmultiSelect'
            }
          },
          individual: {
            label: this.props.translate('individual'),
            value: 'all',
            companies: {
              label: this.props.translate('company'),
              value: [],
              elementConfig: {
                options: [],
                placeholder: this.props.translate('select') + this.props.translate('company')
              },
              inputType: 'newmultiSelect',
              validation: {
                required: true
              },
              touched: false,
              valid: false
            },
            code: ''
          }
        },
        columns: {
          orgChart: {
            label: this.props.translate('orgHierarchy'),
            value: 1,
            inputType: 'radio',
            code: 'ACT01'
            // show: true
          },
          all: {
            label: this.props.translate('all'),
            value: 2,
            inputType: 'radio',
            code: 'ACT02'
          },
          ownOrg: {
            label: this.props.translate('ownOrg'),
            value: 3,
            inputType: 'radio',
            code: 'ACT03'
          },
          assignedOrg: {
            label: this.props.translate('assign') + this.props.translate('organization'),
            value: 4,
            inputType: 'radio',
            code: 'ACT04'
          }
        }
      },
      pages: {
        label: this.props.translate('page') + this.props.translate('access'),
        data: {},
        columns: {
          is_view: {
            label: this.props.translate('view'),
            inputType: 'checkbox'
          },
          is_add: {
            label: this.props.translate('add'),
            inputType: 'checkbox'
          },
          is_edit: {
            label: this.props.translate('edit'),
            inputType: 'checkbox'
          },
          is_delete: {
            label: this.props.translate('delete'),
            inputType: 'checkbox'
          }
        }
      },
      users: {
        label: this.props.translate('assignUser'),
        data: {
          users: {
            label: this.props.translate('users'),
            inputType: 'newmultiSelect',
            value: [],
            elementConfig: {
              placeholder: this.props.translate('select') + this.props.translate('users'),
              options: []
            },
            validation: {
              required: true
            },
            touched: false,
            valid: false
          }
        }
      }
    },
    formIsValid: false,
    searchText: '',
    filter: {},
    form: {
      perspective_name: {
        label: this.props.translate('perspectiveName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('perspectiveName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      perspective_abbr: {
        label: this.props.translate('abbreviation'),
        elementType: 'input',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('abbreviation')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      company_id: {
        label: this.props.translate('select') + this.props.translate('company'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      color_code: {
        label: this.props.translate('color'),
        elementType: 'input',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('color')
        },
        value: '#000000',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      is_active: {
        label: this.props.translate('active'),
        elementType: 'checkbox',
        value: true,
        validation: false,
        valid: true,
        touched: false,
        error: null
      }
    },
    filterControls: {
      company_id: {
        label: this.props.translate('companyName'),
        value: {},
        configs: {
          placeholder: this.props.translate('companyName'),
          options: []
        }
      },
      perspective_id: {
        label: this.props.translate('perspectiveName'),
        value: {},
        configs: {
          placeholder: this.props.translate('perspectiveName'),
          options: []
        }
      },
      is_active: {
        label: this.props.translate('active'),
        value: {},
        configs: {
          placeholder: this.props.translate('active'),
          options: [
            {
              key: 1,
              value: 1,
              label: this.props.translate('active')
            },
            {
              key: 0,
              value: 0,
              label: this.props.translate('inactive')
            }
          ]
        }
      }
    },
    updateProps: {
      filterCompany: this.props.companyOptions
    },
    selectedRecord: null,
    companyFilter: {}
  }

  rowActions = [
    {
      icon: () => <Add />,
      tooltip: this.props.translate('add') + this.props.translate('perspective'),
      onClick: () => this.openModalHandler('add'),
      isFreeAction: true,
      disabled: !this.props.pagePermission.is_add
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: this.props.translate('edit') + this.props.translate('perspective'),
      onClick: (event, rowData) => this.openModalHandler('edit', rowData.perspective_id),
      disabled: !this.props.pagePermission.is_edit
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: this.props.translate('delete') + this.props.translate('perspective'),
      onClick: (event, rowData) => this.openModalHandler('delete', rowData.perspective_id),
      disabled: !this.props.pagePermission.is_delete
    }
  ]

  tableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    {
      field: 'perspective_name',
      title: this.props.translate('perspectiveName'),
      type: 'string'
    },
    {
      field: 'perspective_abbr',
      title: this.props.translate('abbreviation'),
      type: 'string'
    },
    {
      field: 'company.company_name',
      title: this.props.translate('companyName'),
      type: 'string'
    },
    {
      field: 'color_code',
      title: this.props.translate('color'),
      render: rowData => {
        return (
          <div
            style={{
              backgroundColor: rowData.color_code,
              width: '50%',
              height: '20px'
            }}></div>
        )
      },
      width: 100
    },
    {
      field: 'is_active',
      title: this.props.translate('active'),
      render: rowData => {
        return <Checkbox className={classes.Checkbox} checked={!!rowData.is_active} disabled />
      },
      width: 100
    }
  ]

  componentDidMount() {
    this.props.fetchOptions()
    this.props.fetchPerspective()
    this.props.fetchFilter()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.success !== this.props.success && this.props.success) {
      this.props.clearSelectedRecord()
      this.clearModal()
      // this.closeModal()
      this.setState({ actionRecordId: null })
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.selectedRecord !== state.selectedRecord) {
      let formValid = true
      const newFormData = Object.entries(state.form).reduce((formGroups, form) => {
        let [formKey, formAttrs] = form
        let value = ''
        let valid = !formAttrs.validation
        let touched = false
        let errorMessage = null

        if (formAttrs.elementType === 'checkbox') {
          if (props.selectedRecord === null) {
            value = true
          } else {
            value = false
          }
        }
        if (formAttrs.formKey === 'color_code') {
          value = '#000000'
        }
        if (props.selectedRecord && props.selectedRecord[formKey]) {
          value = props.selectedRecord[formKey] || null

          let { isValid, error } = checkValidity(value, formAttrs.validation, formAttrs.label)
          if (formAttrs.elementType === 'newselect') {
            value = state.form[formKey].elementConfig.options.find(res => res.value === value)
          } else if (formAttrs.elementType === 'checkbox') {
            value = !!props.selectedRecord[formKey]
          }
          valid = isValid
          errorMessage = error
        }

        formValid = formValid && valid

        const newFormAttrs = {
          ...formAttrs,
          value: value,
          valid: valid,
          error: errorMessage,
          touched: touched
        }

        return updateObject(formGroups, {
          [formKey]: {
            ...newFormAttrs
          }
        })
      }, {})

      return { form: newFormData, selectedRecord: props.selectedRecord, formIsValid: true }
    }

    if (
      props.companyOptions !== state.companyOptions ||
      state.companyFilter !== props.companyOptions
    ) {
      let targetForm = state.form
      let inputForms = state.filterControls

      let updatedFormItem = updateFormOptions(
        props.companyOptions,
        targetForm.company_id,
        'company_id',
        'company_id',
        'company_name',
        'Select Company Name'
      )
      let updatedFormItemCom = updateFilterOptions(
        props.companyOptions,
        inputForms.company_id,
        'company_id',
        'company_id',
        { code: 'company_code', name: 'company_name' },
        'Select Company'
      )

      return {
        form: updateObject(targetForm, { company_id: updatedFormItem }),
        filterControls: updateObject(inputForms, { company_id: updatedFormItemCom }),
        companyOptions: props.companyOptions,
        companyFilter: props.companyOptions
      }
    }

    if (state.perspectiveFilter !== props.perspectiveOptions) {
      let inputForms = state.filterControls
      let updatedFormItemPer = updateFilterOptions(
        props.perspectiveOptions,
        state.filterControls.perspective_id,
        'perspective_id',
        'perspective_id',
        'perspective_name',
        'Select Perspective'
      )

      return {
        filterControls: updateObject(inputForms, { perspective_id: updatedFormItemPer }),
        perspectiveFilter: props.perspectiveOptions
      }
    }

    return null
  }

  onPageChangeHandler = (event, page) => {
    const pageOptions = {
      page: page,
      perPage: this.props.pagination.perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchPerspective(payload)
  }

  onPerPageChangeHandler = perPage => {
    const pageOptions = {
      page: this.props.pagination.currentPage,
      perPage: perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchPerspective(payload)
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({ searchText: searchText })
  }

  openModalHandler = (action, recordId) => {
    if (action === 'add') {
      this.props.clearSelectedRecord()
    }

    if (recordId && action === 'edit') {
      this.props.fetchPerspectiveById(recordId)
    }

    this.setState({ action: action, actionRecordId: recordId })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.props.fetchOptions()
      this.openModal()
    }
  }

  openModal = () => {
    this.setState({ modalOpen: true, formIsValid: false })
  }

  closeModal = () => {
    this.clearModal()
    this.setState({ modalOpen: false })
  }

  clearModal = () => {
    this.props.clearSelectedRecord()
    let newFormData = Object.entries(this.state.form).reduce((formGroups, form) => {
      let [formKey, formAttrs] = form
      let newFormAttrs
      switch (formKey) {
        case 'is_active':
          newFormAttrs = {
            ...formAttrs,
            value: true
          }
          break
        case 'color_code':
          newFormAttrs = {
            ...formAttrs,
            value: '#000000'
          }
          break
        default:
          newFormAttrs = {
            ...formAttrs,
            value: ''
          }
          break
      }

      return updateObject(formGroups, {
        [formKey]: {
          ...newFormAttrs
        }
      })
    }, {})
    if (this.state.addAno) {
      this.setState({
        form: newFormData,
        actionRecordId: null,
        formIsValid: false,
        addAno: false
      })
    } else {
      this.setState({
        form: newFormData,
        actionRecordId: null,
        formIsValid: false,
        modalOpen: false
      })
    }
  }

  getPageStatus = () => {
    const { lastPage, currentPage, perPage } = this.props.pagination
    return {
      perPage: parseInt(perPage),
      page: lastPage === currentPage ? lastPage - 1 : currentPage
    }
  }

  formSubmitHandler = type => {
    const formData = Object.entries(this.state.form).reduce((formData, formEntry) => {
      let [formKey, formAttrs] = formEntry
      let value = formAttrs.value
      if (formAttrs.elementType === 'newselect' && value) {
        value = formAttrs.value?.value
      }
      return updateObject(formData, { [formKey]: value })
    }, {})
    if (this.state.action === 'add') {
      this.props.createPerspective(formData, this.getPageStatus())
      if (type === 'saveAno') {
        this.setState({
          addAno: true
        })
      }
    } else if (this.state.action === 'edit') {
      this.props.updatePerspective(
        this.state.actionRecordId,
        {
          ...formData
        },
        this.getPageStatus()
      )
    }
  }

  toggleCollapse = groupKey => {
    this.setState(prevState => {
      let collapseItem = {
        ...prevState.form[groupKey]
      }
      return {
        form: updateObject(prevState.form, {
          [groupKey]: {
            ...collapseItem,
            open: !collapseItem.open
          }
        })
      }
    })
  }

  deleteRecord = () => {
    const recordId = this.state.actionRecordId

    this.props.deletePerspective(recordId, this.getPageStatus())

    this.closeConfirmationModal()
  }

  inputChangeHandler = (formKey, event) => {
    const formItem = this.state.form[formKey]

    let inputValue = ''
    if (formItem.elementType === 'textEditor') {
      inputValue = event
    } else if (formItem.elementType === 'newselect') {
      inputValue = event
    } else if (formItem.elementType === 'checkbox') {
      inputValue = event.target.checked
    } else if (formKey === 'color_code') {
      inputValue = event
    } else {
      inputValue = event.target.value
    }

    const { isValid, error } = checkValidity(inputValue, formItem.validation, formItem.label)

    const updatedFormItem = {
      ...formItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }

    const updatedForm = updateObject(this.state.form, { [formKey]: updatedFormItem })

    let formIsValid = true

    Object.entries(updatedForm).map(form => {
      let [, formAttrs] = form
      return (formIsValid = formIsValid && formAttrs.valid)
    })

    this.setState({ form: updatedForm, formIsValid: formIsValid })
  }

  closeConfirmationModal = () => {
    this.setState({ confirmationModalOpen: false, actionRecordId: null })
  }

  openConfirmationModal = recordId => {
    if (recordId) {
      this.setState({ confirmationModalOpen: true })
    }
  }

  closeFilterModal = () => {
    this.props.fetchOptions()
    this.props.fetchFilter()
    this.setState({ filterModalOpen: false })
    this.resetActive()
  }

  openFilterModal = () => {
    this.setState({ filterModalOpen: true })
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]
    if (itemKey === 'company_id') {
      this.props.fetchFilter({ company_id: filterValue?.value })
    }
    this.setState({
      filterControls: updateObject(this.state.filterControls, {
        [itemKey]: {
          ...filterItem,
          value: e
        }
      }),
      filter: {
        ...this.state.filter,
        [itemKey]: filterValue?.value
      }
    })
  }

  resetActive = () => {
    let resetAc = {
      label: this.props.translate('active'),
      value: {},
      configs: {
        placeholder: this.props.translate('active'),
        options: [
          {
            key: 1,
            value: 1,
            label: this.props.translate('active')
          },
          {
            key: 0,
            value: 0,
            label: this.props.translate('inactive')
          }
        ]
      }
    }

    let targetForm = this.state.filterControls

    this.setState({
      filterControls: updateObject(targetForm, { is_active: resetAc })
    })
  }
  filterRecords = () => {
    let param = {
      ...this.state.filter,
      page: 1,
      perPage: this.props.pagination.perPage
    }
    this.props.fetchPerspective(param)

    this.setState({ filterModalOpen: false })
  }

  render() {
    let formGroup = <Spinner />
    if (!this.props.loading) {
      formGroup = (
        <Form
          saved={(formData, event) => this.formSubmitHandler(formData, event)}
          cancelled={this.closeModal}
          form={this.state.form}
          inputChanged={(formKey, e) => this.inputChangeHandler(formKey, e)}
          formValid={this.state.formIsValid}
          selectedRecord={this.props.selectedRecord}
        />
      )
    }

    const footer = (
      <Footer
        save={() => this.formSubmitHandler('save')}
        another={() => this.formSubmitHandler('saveAno')}
        cancel={() => this.closeModal()}
        showAnother={this.state.action === 'add'}
        disable={!validateForm(this.state.form)}
      />
    )
    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
          loadingQueue={this.props.loadingQueue}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate(this.state.action) + this.props.translate('perspective')}
          backdropClicked={this.closeModal}
          footer={footer}>
          {formGroup}
        </Modal>
        <Card>
          <CardHeader>
            <FilterBar buttonClicked={this.openFilterModal} />
          </CardHeader>
          <CardBody>
            <DataTable
              tableTitle={this.props.translate('perspective')}
              data={this.props.data}
              structure={this.tableStructure}
              loading={this.props.loadingQueue.includes('record')}
              pagination={this.props.pagination}
              pageChange={this.onPageChangeHandler}
              perPageChange={this.onPerPageChangeHandler}
              rowActions={this.rowActions}
            />
          </CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.perspective.pagination,
    data: state.perspective.records,
    loading: state.perspective.loading,
    success: state.perspective.success,
    selectedRecord: state.perspective.selectedRecord,
    companyOptions: state.roles.companies,
    passwordPolicyOptions: state.perspective.passwordPolicies,
    ldapServerOptions: state.perspective.ldapServers,
    filterCompany: state.position.filterCompany,
    emailServerOptions: state.perspective.emailServers,
    perspectiveOptions: state.perspective.filterPerspective,
    loadingQueue: state.perspective.loadingStates
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchPerspective: filterOptions => dispatch(actions.fetchPerspective(filterOptions)),
    fetchPerspectiveById: recordId => dispatch(actions.fetchPerspectiveById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedPerspectiveRecord()),
    createPerspective: (recordData, page) => dispatch(actions.createPerspective(recordData, page)),
    updatePerspective: (recordId, recordData, page) =>
      dispatch(actions.updatePerspective(recordId, recordData, page)),
    deletePerspective: (recordId, page) => dispatch(actions.deletePerspective(recordId, page)),
    fetchOptions: () => {
      dispatch(actions.fetchCompanyOptions())
    },
    fetchFilter: filter => {
      dispatch(actions.fetchPerspectiveFiler(filter))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(SetupPerspective))
